import SlideShowSwiper from "./swiper-slide";
import TitleContent from "./title-content";
import MobileCarousel from "./mobile-carousel";
import { useWinnersCtx } from "@/contexts/winners";

export default function MainContent() {
  const { winners } = useWinnersCtx();
  return (
    <div className="mx-auto w-[85%] pb-80 lg:block lg:w-[90%] lg:pb-20">
      <TitleContent />
      <MobileCarousel winners={winners} />
      <SlideShowSwiper winners={winners} />
    </div>
  );
}
